import { Entity } from "../../../game/entity/entity.js";
import type { TileChunk } from "../chunk.js";

export function placeRocks(_chunk: TileChunk, _forrestEntity: Entity) {
    //throw new Error("Function not implemented.");
}
